// import logo from './logo.svg';
// import './App.css';
import './css/styles.css';
// import Header from './components/Common/header'
// import Footer from './components/Common/footer'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
// import { Header, Nav, Sidebar, Footer } from './components/Common'
import { Header, Nav, Footer, AudioPlayer } from './components/common'
import Home from './pages/Home'
import Videos from './pages/Videos'
import Listen from './pages/Listen'
import Exclusive from './pages/Exclusive'
import Unreleased from './pages/Unreleased'
import Social from './pages/Social'
import Error404 from './pages/Error404'

function App() {
  return (
    <Router>
      <Header />
      <Nav />
      <Routes>
        <Route path="/" element={<Home title="WithLeast" />} />
        <Route path="/videos" element={<Videos title="WithLeast Videos" />} />
        <Route path="/listen" element={<Listen title="WithLeast Listen to Mashups" />} />
        <Route path="/exclusive" element={<Exclusive title="WithLeast Listen to Exclusive Mashups" />} />
        <Route path="/unreleased" element={<Unreleased title="WithLeast Unreleased Mashups" />} />
        <Route path="/social" element={<Social title="WithLeast Social" />} />
        <Route path="*" element={<Error404 title="404 - Page not found" />} />
      </Routes>
      <Footer />
      <AudioPlayer />
    </Router>
  );
}

export default App;
